import classNames from 'classnames';
import React, { createContext, useContext } from 'react';
import styles from "./course-card-title.module.css";
/**
 * Context props for `CourseCardTitle`.
 */

/**
 * Context for `CourseCardTitle`. Optionally provide this context in a card to
 * signal layout to `CourseCardTitle` instances rendered by consumers.
 */
export const CourseCardTitleContext = /*#__PURE__*/createContext({
  size: undefined
});
/**
 * Props for `CourseCardTitle`.
 */

/**
 * Title component for `CourseCard`. Renders title text in heading.
 * If `url` is included, will render as anchor link.
 *
 * @remarks
 *
 * Override default rendering of either title text or link by providing
 * `children`, e.g., rendering a `Link`.
 */
export const CourseCardTitle = _ref => {
  var _ref2, _props$size;

  let {
    className,
    url,
    title,
    children,
    id,
    ...props
  } = _ref;
  const {
    size: contextSize
  } = useContext(CourseCardTitleContext);
  const size = (_ref2 = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : contextSize) !== null && _ref2 !== void 0 ? _ref2 : 'medium';
  let content;

  if (children) {
    content = children;
  } else if (title) {
    content = url ? /*#__PURE__*/React.createElement("a", {
      href: url
    }, title) : /*#__PURE__*/React.createElement("span", null, title);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("h3", {
    id: id,
    "data-purpose": "course-title-url",
    className: classNames(className, size === 'small' ? 'ud-heading-sm' : 'ud-heading-md', styles['course-title'])
  }, content));
};
//# sourceMappingURL=course-card-title.react-component.js.map